module.exports = __webpack_public_path__ + "img/linkus-cz.1d38df79.png";